import { render, staticRenderFns } from "./EditCategoryForm.vue?vue&type=template&id=30590ac1&scoped=true&"
import script from "./EditCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EditCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryForm.vue?vue&type=style&index=0&id=30590ac1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30590ac1",
  null
  
)

export default component.exports